import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  samsungWalletInfo: {},
  isLoading: false,
  hasData: false,
  error: "",
  status: "pending"
};
const samsungSlice = createSlice({
  name: "samsungWallet",
  initialState,
  reducers: {
    samsungWalletRequest: (state, action) => {
      state.isLoading = true;
    },
    samsungWalletSuccess: (state, action) => {
      state.isLoading = false;
      state.hasData = true;
      state.error = "";
      state.samsungWalletInfo = action.payload;
      state.status = "success";
    },
    samsungWalletFailure: (state, action) => {
      state.isLoading = false;
      state.error = action?.payload?.response?.data;
      state.samsungWalletInfo = {};
      state.status = "failed";
    },
    resetSamsunWalletInfoStatus: state => {
      state.status = "", state.samsungWalletInfo = {};
    }
  }
});
export const {
  samsungWalletRequest,
  samsungWalletSuccess,
  samsungWalletFailure,
  resetSamsunWalletInfoStatus
} = samsungSlice.actions;
export default samsungSlice.reducer;